import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../core/services/base-crud.service';

@Injectable({
  providedIn: 'root'
})
export class ContactDataService extends BaseCrudService<string, string>{

  private i18nServiceUrl: string = 'i18n/';

  constructor() {
    super();
  }

  getContactInfo(languageKey: string): Observable<string> {
    let headers = new HttpHeaders().set('content-type', 'text/plain; charset=utf-8');
    return this.http.get(this.i18nServiceUrl + 'contact/' + languageKey + '.html', {headers, responseType: 'text'});
  }

}
